import * as React from 'react';
import Router from '../router';
import { IntlProvider } from 'react-intl';
// import  from "./../translations"
import I18n from "./../i18n/I18n";


function App() {
	return <I18n>
		<Router />
	</I18n>
}
export default App;
